import React from "react";
import Button from "./Button";
import IcLocation from "../../images/ic-location.svg";
import IcMoney from "../../images/ic-money.svg";
import { Link } from "react-router-dom";

const CardBlog = ({ data }) => {
  return (
    <div className="bg-white shadow-lg border overflow-hidden rounded mr-3">
      <img src={data.image} className="w-full h-auto" />
      <div className="px-4 my-3 flex flex-col gap-2">
        <div className="flex gap-2 items-center">
          <img
            src={data.photo}
            alt={data.name}
            className="rounded-full w-7 h-7"
          />
          <p className="text-sm">{data.name}</p>
        </div>

        <div className="flex gap-2 items-center text-gray-400 text-sm">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-4 h-4"
          >
            <path
              fillRule="evenodd"
              d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 6a.75.75 0 00-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 000-1.5h-3.75V6z"
              clipRule="evenodd"
            />
          </svg>
          {data.date}
        </div>
        <Link
          to={"#"}
          className="font-semibold text-md hover:text-primary transition-colors duration-200"
        >
          {data.title}
        </Link>
        <p className="text-gray-400 text-sm">{data.description}</p>
      </div>
    </div>
  );
};

export default CardBlog;
